export default "__VITE_ASSET__CeTWHGe4__"